import React from 'react';
import { Button } from 'react-bootstrap';
import { logError } from '../utils/errorLogger';

/**
 * ErrorBoundary catches JavaScript errors in child component render trees
 * and displays a fallback UI instead of a blank screen.
 *
 * This is critical because React unmounts the entire tree on unhandled
 * render errors, leaving users with a blank page.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('[ErrorBoundary] Render error caught:', error, errorInfo);
    logError(error, { componentStack: errorInfo?.componentStack, source: 'errorboundary' });
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="d-flex flex-column align-items-center justify-content-center p-4 text-center" style={{ minHeight: 200 }}>
          <i className="bi bi-exclamation-triangle text-warning" style={{ fontSize: '2rem' }}></i>
          <h5 className="mt-3">Something went wrong</h5>
          <p className="text-muted small mb-3">
            An error occurred while displaying this content. Your data is safe.
          </p>
          <Button variant="primary" size="sm" onClick={this.handleReset}>
            Try Again
          </Button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
